import api from "./api";

export interface KnowledgeMoveFolderItemsParams {
  itemIds: number[];
  targetFolderId: number | number[];
}

// 知识库文件移动
export const knowledgeMoveFolderItems = async (props: KnowledgeMoveFolderItemsParams) => {
  const res = await api.post<unknown>("/knowledge/move_folder_items", {
    item_ids: props.itemIds,
    target_folder_id: props.targetFolderId,
  });
  return res;
};
